import React, { useState, useEffect } from "react";
import SearchTreeSp from "./SearchTreeSp";
import axios from 'axios';
import { BACKEND_URL } from "../../../consts";

const SearchTree = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${BACKEND_URL}/api/v1/tnved/tree?parentId=0`);
                setData(response.data.children);
            } catch (err) {
                setError("Ошибка при загрузке данных. Пожалуйста, попробуйте позже.");
                console.error("Ошибка: ", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div>
            Загрузка...
        </div>;
    }

    if (error) {
        return <div className=" mt-[20px] text-[20px] text-center">
            Ошибка, попробуйте позже
        </div>; 
    }

    const itemsToRender = Array.isArray(data) ? data : [data]; 

    return (
        <div className="flex flex-col gap-[8px] p-[12px]">
            {itemsToRender.map((item, index) => (
                <div key={index} className="bg-[#EFF0F2] rounded-[16px] p-[12px] flex flex-col gap-[8px]">
                    <SearchTreeSp item={item} />
                </div>
            ))}
            
        </div>
    );
};

export default SearchTree;
